import React, { useState, useEffect } from 'react'
import { Typography, Box, Paper, useTheme } from '@mui/material'

import { CardsIcon } from '../Icons/CardsIcon'
import { MainPageBox } from '../DisplayHelpers/MainPageBox'
import {
  sendTrackingEvent,
  toScreenEvent
} from '../../services/amplitude.service'
import { useApp } from '../AppContext/AppProvider'
import WaitlistFormComponent from './Waitlist.form.component'
import { CARD_PROGRAM, WaitlistScreenOpened } from './types'

const WaitlistContainer: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isWaitlisted, setIsWaitlisted] = useState<boolean>(false)

  const theme = useTheme()
  const { application } = useApp()

  const handleSubmit = (email: string): Promise<void> => {
    setIsLoading(true)

    return application
      .service('waitlist/entries')
      .create({ email, creditCardType: CARD_PROGRAM })
      .finally(() => setIsWaitlisted(true))
  }

  useEffect(() => {
    if (!isWaitlisted) {
      sendTrackingEvent(toScreenEvent({ ...WaitlistScreenOpened }))
    }
  }, [])

  return (
    <MainPageBox>
      <Box>
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: '#FFFFFF',
            fontWeight: 500
          }}
        >
          Coming Soon
        </Typography>
      </Box>
      <Paper
        elevation={2}
        sx={{
          position: 'relative',
          maxWidth: 400,
          minWidth: 300,
          borderRadius: 2.5,
          overflow: 'hidden',
          border: '1.5px solid #374353',
          background:
            'radial-gradient(50% 50% at 50% 50%, #083645 0%, rgba(20, 25, 31, 0) 100%)'
        }}
      >
        <Box
          sx={{
            pt: 3,
            borderRadius: '10px 10px 0 0'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'column',
              justifyContent: 'space-around',
              alignItems: 'center'
            }}
          >
            <Typography
              variant="h4"
              component="div"
              fontWeight={400}
              pl={2}
              sx={{
                position: 'absolute',
                top: '16px',
                left: '8px',
                width: '65%',
                backgroundImage: `linear-gradient(225deg, #EBEB47 0%, #47EB99 50%, #47C2EB 100%)`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              You should be rewarded for being active.
            </Typography>

            <CardsIcon
              style={{
                marginTop: '32px',
                height: '12em',
                width: '17em',
                filter: 'drop-shadow(5px 5px 5px rgba(0,0,0,0.3))'
              }}
            />
          </Box>
          {isWaitlisted ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                color: 'secondary.main'
              }}
            >
              <Typography
                component="div"
                variant="h5"
                textAlign="center"
                style={{
                  margin: theme.spacing(2),
                  color: 'white'
                }}
              >
                All Set!
              </Typography>
              <Typography
                component="div"
                variant="subtitle1"
                textAlign="center"
                style={{
                  marginBottom: theme.spacing(2)
                }}
              >
                You're on the waitlist.<br />
                stay tuned for updates.
              </Typography>
            </Box>
          ) : (
            <WaitlistFormComponent onSubmit={handleSubmit} isLoading={isLoading} />
          )}
        </Box>
      </Paper>
    </MainPageBox>
  )
}

export default WaitlistContainer
